module.exports = __webpack_public_path__ + "img/american_express.987b2902.jpg";